export default __webpack_public_path__ + "static/media/twenty-five.abc6a7fb.png";